import React, { FC } from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';
import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import TouchableElement from '@components/common/touchableElement';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';
import ToolIcon from '@v2/components/imageHandling/components/DrawingCanvas/components/ToolIcon';

interface DrawingTopBarProps extends WithColor {
  hasSelection: boolean;
  onDone: () => void;
  onCancel: () => void;
  onDeleteSelected: () => void;
}

const DrawingTopBar: FC<DrawingTopBarProps> = ({ C, hasSelection, onDone, onCancel, onDeleteSelected }) => {
  return (
    <View
      testID={TEST_IDS.drawingCanvas.topBar}
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: scale(12),
        paddingVertical: scale(8),
        gap: scale(8),
        backgroundColor: C('Background/Light/Panel [web]'),
        borderBottomWidth: 1,
        borderBottomColor: C('Content/Light/Tertiary'),
      }}
    >
      <TouchableElement testID={TEST_IDS.drawingCanvas.cancelButton} onPress={onCancel}>
        {({ boxStyle }) => (
          <View
            style={[
              boxStyle,
              {
                flexDirection: 'row',
                alignItems: 'center',
                gap: scale(6),
                paddingHorizontal: scale(12),
                paddingVertical: scale(8),
                borderRadius: scale(8),
                backgroundColor: C('Button/Light/Secondary'),
              },
            ]}
          >
            <ToolIcon name="close" color={C('Label/Light/Primary')} size={scale(16)} />
            <Text style={[font.Body, { color: C('Label/Light/Primary') }]}>{i18n.t('Cancel')}</Text>
          </View>
        )}
      </TouchableElement>
      {hasSelection ? (
        <TouchableElement testID={TEST_IDS.drawingCanvas.deleteButton} onPress={onDeleteSelected}>
          {({ boxStyle }) => (
            <View
              style={[
                boxStyle,
                {
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: scale(6),
                  paddingHorizontal: scale(12),
                  paddingVertical: scale(8),
                  borderRadius: scale(8),
                  backgroundColor: C('Background/Light/Error soft'),
                },
              ]}
            >
              <ToolIcon name="trash" color={C('Label/Light/Error')} size={scale(16)} />
              <Text style={[font.Body, { color: C('Label/Light/Error') }]}>{i18n.t('Delete')}</Text>
            </View>
          )}
        </TouchableElement>
      ) : null}
      <View style={{ flex: 1 }} />
      <TouchableElement testID={TEST_IDS.drawingCanvas.doneButton} onPress={onDone}>
        {({ boxStyle }) => (
          <View
            style={[
              boxStyle,
              {
                flexDirection: 'row',
                alignItems: 'center',
                gap: scale(6),
                paddingHorizontal: scale(16),
                paddingVertical: scale(8),
                borderRadius: scale(8),
                backgroundColor: C('Button/Light/Primary'),
              },
            ]}
          >
            <ToolIcon name="check" color={C('Label/Light/AlwaysLight Primary')} size={scale(16)} />
            <Text style={[font.Body, { color: C('Label/Light/AlwaysLight Primary') }]}>{i18n.t('Done')}</Text>
          </View>
        )}
      </TouchableElement>
    </View>
  );
};

export default ColorWrapper(DrawingTopBar);
